import Vue from 'vue';
import Vuex from 'vuex';
import requests from '@/utils/requests';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        newestPostList: {},
        pageType: '',
        currentType: '',
        promoterId: 'U2FsdGVkX1%2FNlsUYkuwFa12SHI%2BxzG2XC2Q%2F%2FEVkeKE%3D',
        // promoterId: '',
        searchText: '',
        fixedCompany: '',
        fixedCompanyIds: ''
    },
    mutations: {
        // 保存最新岗位
        saveNewestPost(state, data) { state.newestPostList = data; },
        // 获取页面类型
        getPageType(state) {
            // 判断是否存在类型
            if (window.sessionStorage.getItem('ptlPageType')) {
                state.pageType = window.sessionStorage.getItem('ptlPageType');
                return;
            }
            // 获取页面为index时的类型
            const query = window.location.search.substring(1);
            const array = query.split('&');
            let type = null;
            for (const item of array) {
                var pair = item.split('=');
                if (pair[0] === 'type' && ['worker', 'social', 'campus'].indexOf(pair[1]) !== -1) {
                    type = pair[1];
                }
            }
            // 获取其他页面类型
            for (const item of ['/worker/', '/social/', '/campus/']) {
                if (window.location.href.indexOf(item) !== -1) {
                    type = item.substring(1, item.length - 1);
                }
            }
            if (window.location.href.indexOf('recommend') !== -1) {
                type = window.location.href.indexOf('recommended') !== -1 ? 'recommended' : 'recommend';
                if (type === 'recommended') {
                    state.searchText = window.location.search;
                }
            }
            if (!type) {
                return;
            }
            state.pageType = type;
            window.sessionStorage.setItem('ptlPageType', type);
        },
        changeCurrentType(state, type) {
            state.currentType = type;
        },
        // 保存推荐人ID
        getPromoterId(state) {
            const query = window.location.search.substring(1);
            const array = query.split('&');
            let id = null;
            for (const item of array) {
                var pair = item.split('=');
                if (pair[0] === 'promoterId') {
                    id = pair[1];
                }
            }
            state.promoterId = id;
        },
        savePromoterId(state, id) {
            state.promoterId = id;
        },
        saveFixedCompany(state, fixedCompany) {
            state.fixedCompany = fixedCompany;
            state.fixedCompanyIds = fixedCompany === 'zc' ? '3,14,18,19,25' : '';
            window.sessionStorage.setItem('PTLRecruitFixed', fixedCompany);
        },
        getFixedCompanyIds(state) {
            let companyName = '';
            switch (state.fixedCompany) {
            case 'zc':
                companyName = '紫宸';
                break;
            default:
                companyName = '';
            }
            if (companyName) {
                requests.job.getAllOrg().then(v => {
                    const ids = [];
                    v.forEach(item => {
                        if (item.orgName.indexOf(companyName) !== -1) {
                            ids.push(item.orgId);
                        }
                    });
                    state.fixedCompanyIds = ids.join(',');
                });
            }
        }
    },
    actions: {
    },
    modules: {
    }
});
